module.exports = __webpack_public_path__ + "img/menu-shouquan.ec512762.svg";